import React, { useMemo, useState, useEffect } from 'react';
import awardPrizeService from 'lib/services/awardPrizeService';
import { useUserRewardStore } from 'lib/store/userRewardStore';
import { useLotteryPrizeStore } from 'lib/store/lotteryPrizeStore';
import { useFreeLotteryStore } from 'lib/store/freeLotteryStore';
import { useMobileStore } from 'lib/store/mobileStore';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import IndependentDialog from '../IndependentDialog';
import PrizeInfoCard from '../CommonPrizeInfoCard';
import { showDebrisRecordDialog } from '../DebrisRecordDialog';
import { showIndependentModal } from '../Modal';
import FramentPrizeInfoCard from '../FragmentPrizeInfoCard';
import './index.scss';

interface UserRewardDialogProps {
  closeModal?: () => void;
  freeLotteryId?: string;
  title?: string;
  lotteryActivityId?: string;
}

const UserRewardDialog = ({
  closeModal,
  title = '',
  freeLotteryId = '',
  lotteryActivityId = '',
}: UserRewardDialogProps) => {
  const {
    queryCommonPrizeResult,
    queryFragmentPrizeResult,
    commonPrizeResult,
    unusedFragmentList,
    setLotteryActIdList,
  } = useUserRewardStore((state) => state);
  const { inputMobile } = useMobileStore((state) => state);
  const { freeLotteryActivityId } = useFreeLotteryStore((state) => state);
  const { lotteryActId } = useLotteryPrizeStore((state) => state);
  const [isFragment, setIsFragment] = useState(false);

  useEffect(() => {
    const formatfreeLotteryId = freeLotteryActivityId || +freeLotteryId;
    setLotteryActIdList(formatfreeLotteryId); // 免费抽奖
    setLotteryActIdList(lotteryActId);
    setLotteryActIdList(+lotteryActivityId); // 兼容其他抽奖活动
    report(ATTA_REPORT.USER_REWARD.MYREWARD_REWARD_SHOW);
  }, []);

  useEffect(() => {
    isFragment ? queryFragmentPrizeResult() : queryCommonPrizeResult(inputMobile);
    isFragment && report(ATTA_REPORT.USER_REWARD.MYREWARD_FRAGMENTTAB_SHOW);
  }, [isFragment]);

  const receivedCallback = () => {
    // 获取领取状态，这个里面按照
    setTimeout(() => {
      queryCommonPrizeResult(inputMobile);
    }, 500);
  };
  const receiveAward = (prizeInfo) => {
    awardPrizeService.receiveCommonLotteryGift({ ...prizeInfo }, receivedCallback);
  };

  const showFragmentsConsumeDialog = () => {
    showDebrisRecordDialog({
      title: '- 碎片消耗记录 -',
      confirmButtonText: '确认',
      bottomText: '仅展示最近99条记录～',
      closeModal: () => {},
    });
  };

  const handleSwitch = (isFragment) => setIsFragment(!isFragment);

  const prizeList = useMemo(() => (isFragment ? unusedFragmentList : commonPrizeResult), [
    isFragment,
    unusedFragmentList,
    commonPrizeResult,
  ]);

  return (
    <IndependentDialog title={title || '我的奖励'} showConfirm={false} closeModal={closeModal}>
      <div className="my-reward-dialog__wrapper">
        <div className="my-reward-button__group my-reward-button__border">
          <div
            className={`my-reward-button ${isFragment ? '' : 'left-selected'} left`}
            onClick={() => handleSwitch(true)}
          >
            奖励
          </div>
          <div
            className={`my-reward-button ${isFragment ? 'right-selected' : ''} right`}
            onClick={() => handleSwitch(false)}
          >
            碎片奖励
          </div>
        </div>
        {prizeList?.length ? (
          <div className="my-reward-dialog">
            <div className="deliver-tips">
              {isFragment ? '点击已翻开的奖励图可查看详情哦～' : '点击已翻开的奖励图可查看/领奖哦～'}
            </div>
            <div className="prize-list">
              {!isFragment &&
                prizeList.map((item, index) => (
                  <PrizeInfoCard receiveAward={receiveAward} key={index} prizeInfo={item} />
                ))}
              {isFragment &&
                prizeList
                  .sort((a, b) => a.grantTime - b.grantTime)
                  .map((item, index) => <FramentPrizeInfoCard key={index} prizeInfo={item} />)}
            </div>
          </div>
        ) : (
          <div className="empty-dialog">
            <img
              className="empty-dialog__icon"
              src="https://act.ecovision.gtimg.com/static/imgs/static/static_1720144820422.png"
              alt="[图片]"
            />
            <div>空空如也</div>
            <div>快去参与一下～</div>
          </div>
        )}
        {isFragment ? (
          <div onClick={showFragmentsConsumeDialog} className="fragments_consume_button">
            {'碎片消耗记录>>'}
          </div>
        ) : null}
      </div>
    </IndependentDialog>
  );
};

export const showUserRewardDialog = ({ freeLotteryId = '', lotteryActivityId = '', title = '' } = {}) =>
  showIndependentModal(
    <UserRewardDialog title={title} lotteryActivityId={lotteryActivityId} freeLotteryId={freeLotteryId} />,
    {
      onBottom: false,
    },
  );
